.right {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
  align-items: center;
}

.close-button {
  all: unset;
  cursor: pointer;
  border-radius: 0.4rem;
  display: flex;
  height: 2.4rem;
  width: 2.4rem;
  justify-content: center;
  align-items: center;

  svg {
    width: 0.8rem;
    height: 0.8rem;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--color-grayscale-arsenic);
    & svg,
    & svg > * {
      fill: var(--color-grayscale-white);
    }
  }
}

.collaborator-item {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  justify-content: space-between;
}

.left {
  display: flex;
  flex-direction: row;
  gap: 0.8rem;
}

.member-info {
  display: flex;
  flex-direction: column;

  span:first-child {
    color: var(--color-grayscale-white, #fafafa);
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.4rem;
    font-weight: 400;
    line-height: 1.8rem;
  }

  span:last-child {
    color: var(---color-grayscale-light-slate, #7a8296);
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 1.4rem;
  }
}

.list {
  border-top: 0.1rem solid var(--color-stroke-default);
  padding: 1.6rem 0;
  margin-top: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;

  @media screen and (min-width: $bp-medium) {
    height: 26.4rem;
  }
}

.collaborators-placeholder {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  justify-content: center;
  align-items: center;
  height: 26.4rem;

  margin-top: 1.6rem;
  padding: 2.4rem 1.6rem;
  border-top: 0.1rem solid var(--color-grayscale-tuna);

  & > span {
    color: var(--color-grayscale-shuttle, #626878);
    text-align: center;
    font-size: 1.6rem;
    font-weight: 400;
  }
}

.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  cursor: default;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    max-width: min(48rem, 80vw);
    min-width: min(48rem, 80vw);
  }
}

.server-error {
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  align-items: center;
  justify-content: center;
  padding: 2.4rem 0;
}

.role-label {
  color: var(--color-grayscale-white, #fafafa);
  text-transform: capitalize;
  font-size: 1.4rem;
  font-weight: 400;
  user-select: none;
}

.trigger {
  all: unset;
  user-select: none;
  display: flex;
  cursor: pointer;

  & + *[data-radix-popper-content-wrapper] {
    & > [data-radix-menu-content] {
      backdrop-filter: unset;
      background: var(--color-grayscale-tuna, #31343c);
      box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
      border-radius: var(--border-radius-small);
    }
  }
}

.tooltip-child {
  user-select: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.4rem;
}
